import IconButton from "@vapor/react-material/IconButton";
import AppsIcon from "@mui/icons-material/Apps";

import { useTargetUrl } from "../service-axios";

export const AppSwitch = () => {
  const catalog = useTargetUrl("loginApp://catalog");

  return (
    <IconButton
      aria-label="delete"
      onClick={() => (window.location = catalog.url)}
    >
      <AppsIcon sx={{ color: "white" }} />
    </IconButton>
  );
};
